export default __webpack_public_path__ + "static/media/ciboa.5d027acb.jpg";